import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['field', 'counter']
  static values = { maxLength: Number, minLength: Number }
  static classes = ['invalid']
  isValid = true

  connect () {
    this.#init()
  }

  handleInput (event) {
    const { length } = event.target.value

    this.#setCounter(length)
    this.#checkValidity()
  }

  #init () {
    const valueLength = this.fieldTarget.value.length
    this.#setCounter(valueLength)
    this.#checkValidity()
  }

  #setCounter (length) {
    if (this.hasMinLengthValue && this.minLengthValue > 0) {
      // Min mode: progress toward the required minimum ("158 / 500").
      this.counterTarget.textContent = `${length} / ${this.minLengthValue}`
      this.isValid = length >= this.minLengthValue
      return
    }

    const counter = this.maxLengthValue - length
    this.counterTarget.textContent = counter

    this.isValid = counter > 0
  }

  #checkValidity () {
    if (this.hasMinLengthValue && this.minLengthValue > 0) {
      this.counterTarget.classList.toggle('text-success', this.isValid)
      this.counterTarget.classList.toggle('text-muted', !this.isValid)
      return
    }

    if (this.isValid) {
      this.counterTarget.classList.remove(this.invalidClass)
    } else {
      this.counterTarget.classList.add(this.invalidClass)
    }
  }
}
